import React, { memo } from 'react';

import { Status } from 'types/items';

import { OrdersTable } from './OrdersTable';

type Props = {
  startDate?: Date;
  endDate?: Date;
  isDeleting: boolean;
  venue?: string[];
  accountManagers?: string[];
  onDelete: (ids: string[], onSuccess: () => void) => void;
  invoiced: boolean | undefined;
  feeAdjustmentTypes?: string[];
  search?: string;
};

export const AllOrders = memo<Props>((props) => {
  const {
    endDate,
    startDate,
    venue,
    accountManagers,
    invoiced,
    feeAdjustmentTypes,
    search,
  } = props;

  return (
    <OrdersTable
      statusKey="all"
      excludeStatus={[Status.CUSTOMER_REQUEST, Status.REJECTED]}
      endDate={endDate}
      startDate={startDate}
      venue={venue}
      accountManagers={accountManagers}
      invoiced={invoiced}
      feeAdjustmentTypes={feeAdjustmentTypes}
      search={search}
    />
  );
});
